module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-LightItalic.5e03c24.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sourceSansPro/SourceSansPro-LightItalic.woff
// module id = dHxC
// module chunks = 27